import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { suppressTicketXdr, ticketXdrSuppressQuery } from '../api/securitee'
import { Spinner } from '../ui/Spinner'
import { toast } from '../ui/notify'

/**
 * "Suppress similar" pe un incident marcat Fals pozitiv (docs XDR 02, F4):
 * evenimentele de acelasi fel - acelasi canal, eventID si camp stabil (calea,
 * contul, IP-ul) - nu mai pleaca spre Wazuh pe firma tichetului, deci nu mai
 * fac tichete. Cu motiv si expirare (90 de zile implicit, cel mult un an).
 */
export function XdrSuppress({ ticket, detection }: { ticket: number; detection: number }) {
  const query = useQuery(ticketXdrSuppressQuery(ticket, detection))
  const [reason, setReason] = useState('')
  const [days, setDays] = useState(90)
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState('')
  const [refusal, setRefusal] = useState('')

  if (query.isPending) return <Spinner />

  if (query.isError) {
    return <p className="font-grey-cascade">{query.error instanceof Error ? query.error.message : 'This detection cannot be suppressed.'}</p>
  }

  if (done !== '') return <p className="color-green">{done}</p>

  const what = query.data

  const send = async () => {
    setBusy(true)
    setRefusal('')

    try {
      const answer = await suppressTicketXdr(ticket, detection, reason, days)
      const until = answer.expires_at.slice(0, 10)

      setDone(answer.extended ? `Existing suppression extended until ${until}.` : `Suppressed until ${until}.`)
      toast('Similar events will no longer raise a detection.', 'XDR', 'success')
    } catch (e) {
      setRefusal(e instanceof Error ? e.message : 'The suppression was not saved.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="xdr-suppress-form">
      <p>
        Events with <code className="xdr-value">{what.field} = {what.value}</code> ({what.channel} {what.event_id}, rule {what.rule_id}) will no
        longer raise a detection for this company.
        {what.existing ? <span className="font-grey-cascade"> A suppression is already active until {what.existing.expires_at.slice(0, 10)}; it will be extended.</span> : null}
      </p>
      <label htmlFor={`xdr-suppress-reason-${detection}`}>Why are they known?</label>
      <textarea id={`xdr-suppress-reason-${detection}`} className="form-control" rows={2} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} />
      <div className="xdr-suppress-days">
        <label htmlFor={`xdr-suppress-days-${detection}`}>For</label>
        <input id={`xdr-suppress-days-${detection}`} type="number" className="form-control input-sm" min={1} max={365} value={days} onChange={(e) => setDays(Number(e.target.value))} />
        <span>days</span>
        <button type="button" className="btn btn-sm btn-warning" disabled={busy || reason.trim() === '' || days < 1 || days > 365} onClick={() => void send()}>
          Suppress
        </button>
      </div>
      {refusal !== '' && (
        <p className="color-red" role="alert">
          {refusal}
        </p>
      )}
    </div>
  )
}
